import type { ConfigProviderProps } from 'antd';
import { theme } from 'antd';
import { useMemo } from 'react';

const useAntTheme = () => {
  return useMemo<ConfigProviderProps>(
    () => ({
      theme: {
        algorithm: theme.defaultAlgorithm,
        token: {},
        components: {},
      },
    }),
    []
  );
};

export default useAntTheme;
